import { Capabilities } from 'app/utils/Capabilities';
import { hasPointerEvent, hasTouchEvent } from './caniuse';
const getDocument = () => typeof document !== 'undefined' ? document : {};
const getWindow = () => (typeof window !== 'undefined' ? window : {});
export const removeDocumentListener = (event, handler, capture) => getDocument().removeEventListener(event, handler, capture);
export const addDocumentListener = (event, handler, capture) => {
    getDocument().addEventListener(event, handler, capture);
    return () => removeDocumentListener(event, handler, capture);
};
export const removeWindowListener = (event, handler, capture) => getWindow().removeEventListener(event, handler, capture);
export const addWindowListener = (event, handler, capture) => {
    getWindow().addEventListener(event, handler, capture);
    return () => removeWindowListener(event, handler, capture);
};
export function getDoubleTapClosure(listener, waitMS = 500) {
    let lastTap = 0;
    let timeout;
    return function detectDoubleTap(event) {
        const curTime = new Date().getTime();
        const tapLen = curTime - lastTap;
        if (tapLen < waitMS && tapLen > 0) {
            listener(event);
            event.preventDefault();
        }
        else {
            timeout = setTimeout(() => {
                clearTimeout(timeout);
            }, 500);
        }
        lastTap = curTime;
    };
}
export const addDoubleTapListener = (node, listener) => {
    if (Capabilities.shared.isMobileDevice) {
        const $listener = getDoubleTapClosure(listener);
        node.addEventListener('pointerup', $listener, true);
        return () => {
            node.removeEventListener('pointerup', $listener, true);
        };
    }
    node.addEventListener('dblclick', listener, true);
    return () => {
        node.removeEventListener('dblclick', listener, true);
    };
};
export const getEventPosition = (event, key = 'client') => {
    const xkey = `${key}X`;
    const ykey = `${key}Y`;
    if (hasTouchEvent()) {
        // eslint-disable-next-line dot-notation
        const TouchEventCls = window['TouchEvent'];
        if (event instanceof TouchEventCls) {
            const touch = event.touches.item(0);
            if (touch) {
                return { x: touch[xkey], y: touch[ykey] };
            }
        }
    }
    if (hasPointerEvent()) {
        if (event instanceof PointerEvent) {
            return { x: event[xkey], y: event[ykey] };
        }
    }
    if (event instanceof MouseEvent) {
        return { x: event[xkey], y: event[ykey] };
    }
    return { x: 0, y: 0 };
};
export const getInteractionStartEventType = () => {
    if (hasPointerEvent()) {
        return 'pointerdown';
    }
    if (Capabilities.shared.isMobileDevice && hasTouchEvent()) {
        return 'touchstart';
    }
    return 'mousedown';
};
export function stopPropagation(event) {
    try {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();
    }
    catch (err) {
        /* noop */
    }
}
